import { CollapseAllOutlineIcon } from './CollapseAllOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8672E491-9415-4259-A9E5-E0E3552187CB
 * name collapse-all-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/collapse-all-outline.svg
 * tags
 */
export const AnimationMinusOutlineIcon = CollapseAllOutlineIcon;
export default AnimationMinusOutlineIcon